// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as Form from "@sothebys/sterling/form";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as Utils_Agreements$LiveRoom from "../Utils/Utils_Agreements.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

var linkStyle = Curry._1(Css.style, {
      hd: Css.textDecoration("none"),
      tl: {
        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue60_nohashtag)),
        tl: /* [] */0
      }
    });

function NBAAgreement(props) {
  var onUpdateAgreementStatuses = props.onUpdateAgreementStatuses;
  var agreementStatuses = props.agreementStatuses;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var match$1 = React.useState(function () {
        return Belt_Option.getWithDefault(Js_dict.get(agreementStatuses, Utils_Agreements$LiveRoom.nbaAgreementId), false);
      });
  var setChecked = match$1[1];
  var checked = match$1[0];
  React.useEffect((function () {
          Curry._1(onUpdateAgreementStatuses, Js_dict.fromArray([[
                      Utils_Agreements$LiveRoom.nbaAgreementId,
                      checked
                    ]]));
        }), []);
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: /* [] */0
                  })
            }, React.createElement(Form.Checkbox, {
                  name: "NBAAgreement-LiveRoom",
                  checked: checked,
                  onChange: (function ($$event) {
                      var newChecked = $$event.target.checked;
                      Curry._1(setChecked, (function (param) {
                              return newChecked;
                            }));
                      Curry._1(onUpdateAgreementStatuses, Js_dict.fromArray([[
                                  Utils_Agreements$LiveRoom.nbaAgreementId,
                                  newChecked
                                ]]));
                    })
                }), React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.marginLeft(Css.px(8)),
                        tl: /* [] */0
                      }),
                  children: null
                }, Curry._1(t, "NBAAgreementText"), React.createElement("a", {
                      className: linkStyle,
                      href: "https://www.nba.com/privacy-policy",
                      target: "_blank"
                    }, Curry._1(t, "NBAAgreementText_PrivacyPolicy")), Curry._1(t, "NBAAgreementText_And"), React.createElement("a", {
                      className: linkStyle,
                      href: "https://www.nba.com/termsofuse",
                      target: "_blank"
                    }, Curry._1(t, "NBAAgreementText_TermsOfUse"))));
}

var make = NBAAgreement;

export {
  linkStyle ,
  make ,
}
/* linkStyle Not a pure module */
